export class Signature{
    img:string;
    text:string;
    id:number;
}